import type { App } from 'vue'

import ElementPlus, { ElInputNumber } from 'element-plus'

export const setupElementPlus = (app: App<Element>) => {
  // 全站数字输入框不展示左右加减按钮，仅保留直接输入
  if (ElInputNumber.props?.controls) {
    ElInputNumber.props.controls.default = false
  }

  // 使用全量导入 Element Plus
  app.use(ElementPlus)

  // 导入全量样式
  import('element-plus/dist/index.css')
}

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
// import { ElLoading, ElScrollbar } from 'element-plus'

// const plugins = [ElLoading]

// const components = [ElScrollbar]

// export const setupElementPlus = (app: App<Element>) => {
//   plugins.forEach((plugin) => {
//     app.use(plugin)
//   })

//   // 为了开发环境启动更快，一次性引入所有样式
//   if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
//     import('element-plus/dist/index.css')
//     return
//   }

//   components.forEach((component) => {
//     app.component(component.name!, component)
//   })
// }
